import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$accountFactory} from "../../../account/$account.factory";

export class editCoordinationCtrl implements IController {

  coordination: any;

  private coordinationRef: any;
  private payload: any;
  private loading: boolean;
  private packageTypes: any;
  private timeSlots: any;
  private daysSelection: any;
  private minDate: any;

  /* @ngInject */
  constructor(private commonsConstants, private CoordinationConstants, private $log,
              private $account: $accountFactory, private $state, private $filter, private $coordinations, private moment) {
  }

  $onInit() {

    this.coordinationRef = this.$coordinations(this.coordination.id);
    this.payload = angular.copy(this.coordination);
    this.loading = false;
    this.packageTypes = this.commonsConstants.packageTypes;
    this.timeSlots = this.CoordinationConstants.timeSlots;
    this.coordination.slaNotBefore = new Date(this.coordination.slaNotBefore);
    this.payload.slaNotBefore = new Date(this.coordination.slaNotBefore);
    this.payload.slaNotAfter = new Date(this.coordination.slaNotAfter);
    this.payload.packageList = this.coordination.packageList[0];
    this.daysSelection = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.minDate = this.moment().startOf('day').toDate();

    if (_.has(this.payload, 'ownerDetails.phoneNumber')) {
      this.payload.ownerDetails.phoneNumber = this.$filter('bringozPhone')(this.coordination.ownerDetails.phoneNumber);
    }
  };

  /////////////////////////////////////////////////////////////////////

  // ******************************
  // External methods
  // ******************************

 onSelectAccount(accountId) {
    if (!accountId) {
      this.payload.ownerId = null;
      this.payload.ownerDetails = {}
    } else {
      this.payload.ownerId = accountId;
      this.$account(accountId).$asyncValue()
        .then((account) => {
          this.payload.ownerDetails = {
            name: account.name,
            phoneNumber: this.$filter('bringozPhone')(account.phoneNumber),
            address: account.address
          }
        })
        .catch((error) => {
          this.$log.error('Failed to get account, ' +
            'createNewCoordination@onSelectAccount', error)
        })
    }
  }

  onAddressChange(address) {
    if (!address || _.isEmpty(address)) {
      _.unset(this.payload.ownerDetails, 'address');
    } else {
      this.payload.ownerDetails.address = address;
    }
  }

  onMinDateChange(selectedDate) {
    if (selectedDate > this.payload.slaNotAfter) {
      this.payload.slaNotAfter = selectedDate;
    }
  }

  onMaxDateChange(selectedDate) {
   this.payload.slaNotBefore = selectedDate;
  }

  onSelectServiceAreas(serviceAreas) {
    this.payload.serviceAreaList = serviceAreas;
  }

  submitForm(form) {
    form.$setSubmitted(true);
    if (form.$valid) {
      const payload = angular.copy(this.payload);

      if (this.payload.ownerDetails.phoneNumber) {
        payload.ownerDetails.phoneNumber = this.$filter('bringozPhonePrefix')(this.payload.ownerDetails.phoneNumber)
      }
      payload.slaNotBefore =  this.moment(payload.slaNotBefore).startOf('day').valueOf();
      payload.slaNotAfter =  this.moment(payload.slaNotAfter).endOf('day').valueOf();

      if (payload.ownerDetails.phoneNumber) {
        payload.ownerDetails.phoneNumber =  this.$filter('bringozPhonePrefix')(this.payload.ownerDetails.phoneNumber);
      }

      payload.packageList = [payload.packageList];
      // if (!_.isEqual(payload, ctrl.payload)) {
      //     doUpdate(payload);
      // }
      this.doUpdate(payload);
    }

  }

  // ******************************
  //        Internal methods
  // ******************************

  doUpdate(payload) {
    this.loading = true;
    this.coordinationRef.$post(payload)
      .then(() => {
        this.loading = false;
        this.$state.go('coordination-detail', {id: this.coordination.id});
      })
      .catch((error) => {
        this.loading = false;
        this.$log.error('Failed to create new coordination , ' +
          'createNewCoordination@doUpdate \n' + error);
      })
  }

}

angular
  .module('bringoz.admin.coordinations')
  .component('editCoordination', {
    bindings: {
      coordination: '<'
    },
    templateUrl : 'app/modules/coordinations/components/edit-coordination/edit-coordination.html',
    controller: editCoordinationCtrl
  });

